import { Beleg } from '../../types';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currentBelegSize',
  standalone: true,
})
export class CurrentBelegSizePipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public transform(beleg: Beleg, justSomethingToTrickChangeDetection: number): Promise<number> {
    return beleg.getBelegSize();
  }
}
